export default __webpack_public_path__ + "static/media/example.641b480b.csv";